import React, { useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
// @material-ui/lab components
// @material-ui/icons components
// core components
// import OutlinedInput from "@material-ui/core/OutlinedInput";
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";
import QrReader from "react-qr-reader";
import Tooltip from "@material-ui/core/Tooltip";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
// import FormGroup from "@material-ui/core/FormGroup";
// import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import Check from "@material-ui/icons/Check";
import {
  getLaundryOrderDetails,
  bulkUpdateOrderStatus,
  getActiveServicesWithoutSubs,
} from "../../network/ApiAxios";
import { redirectToLogout } from "common/SharedFn";
import { ArrowBack } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import plusIcon from "assets/img/icons/doobi/count-add.png"; // Import the plus icon image
import minusIcon from "assets/img/icons/doobi/count-minus.png"; // Import the minus icon image

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const ScanQrCodesPage = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const [alert, setAlert] = React.useState(false);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [success, setSuccess] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const [id, setId] = useState();
  const [forceRefresh, setForceRefresh] = useState(false);
  const [qrScanRead, setQrScanRead] = useState(false);
  const [order, setOrder] = useState();
  const [services, setServices] = useState([]);
  const [qrScans, setQrScans] = useState([]);
  const [selectedBagId, setSelectedBagId] = useState();
  const [scanQrModal, setScanQrModal] = useState(false);
  const [itemsModal, setItemsModal] = useState(false);
  const [executeStatusUpdate, setExecuteStatusUpdate] = useState(false);
  const [file, setFile] = React.useState(null);
  const [uploadFiles, setUploadFiles] = useState([]);
  const [currentSequence, setCurrentSequence] = useState(0);
  const [imageUrl, setImageUrl] = useState("");
  const [counts, setCounts] = useState({});  
  // const [countChanges, setCountChanges] = useState(false);
  var currentOrderId = props.match.params.id;
  var sequence = 0;
  var totalItems = {};
  let history = useHistory();

  let fileInput = React.createRef();

  const handleImageChange = (e, sequence) => {
    e.preventDefault();
    let reader = new FileReader();
    let fileArray = [];
    let newFile = e.target.files[0];
    let uploadFile = {
      sequence: sequence,
      file: e.target.files[0],
    };
    fileArray.push(newFile);
    if (uploadFiles && uploadFiles?.find((x) => x?.sequence === sequence)) {
      let newData = [...uploadFiles];
      newData[sequence][file] = e.target.files[0];
      setUploadFiles(newData);
    } else {
      let newData = [...uploadFiles, uploadFile];
      setUploadFiles(newData);
    }
  };

  const tableCellHeadTableHeadClassesObj = {
    root: classes.tableCellRoot + " " + classes.tableCellRootHead,
  };

  const handleQrScan = (data) => {
    if (data && !qrScanRead) {
      setQrScanRead(true);
      var found = false;
      for (var i = 0; i < qrScans.length; i++) {
        if (qrScans[i].tag === data) {
          qrScans[i].isScanned = true;
          found = true;
          break;
        }
      }
      if (!found) {
        showErrorNotification("QR does not belong to order");
      }
      setScanQrModal(false);
      setQrScanRead(false);
      // fetchOrderDetails(data);
    }
  };
  const handleQrError = (err) => {
    console.error(err);
    setScanQrModal(false);
  };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const incrementCount = (subServiceId) => {
    setCounts((prevCounts) => ({
      ...prevCounts,
      [subServiceId]: (prevCounts[subServiceId] || 0) + 1,
    }));
  };

  const decrementCount = (subServiceId) => {
    if (counts[subServiceId] > 0) {
      setCounts((prevCounts) => ({
        ...prevCounts,
        [subServiceId]: prevCounts[subServiceId] - 1,
      }));
    }
  };

  const accessOrderPage = (id) => {
    let history = createHistory();
    history.push("/admin/laundryOrders/" + id);
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };

  const updateStatusAction = async (newStatus) => {
    setExecuteStatusUpdate(false);
    setIsLoading(true);
    try {
      const newArrayOfFiles = uploadFiles.map((x) => x?.file);
      var qrs = [];
      for (var i = 0; i < qrScans.length; i++) {
        qrs.push(qrScans[i].tag);
      }
      totalItems = {};
      for (const qrScan of qrScans) {
        if(qrScan.items == null){
          continue;
        }
        for (const key in qrScan.items) {
          if (qrScan.items.hasOwnProperty(key)) {
            if (totalItems.hasOwnProperty(key)) {
              totalItems[key] += qrScan.items[key];
            } else {
              totalItems[key] = qrScan.items[key];
            }
          }
        }
      }
      const response = await bulkUpdateOrderStatus(
        [order.id],
        newStatus,
        null,
        newArrayOfFiles,
        qrs,
        JSON.stringify(totalItems)
      );
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Status Updated Successfully");
        accessOrderPage(order.id);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    } catch (ex) {
      showErrorNotification("Failed to update status");
      setIsLoading(false);
    }
  };

  const fetchOrderDetails = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    try {
      const response = await getLaundryOrderDetails(currentOrderId);
      const responseServices = await getActiveServicesWithoutSubs();
      const { data } = response;
      if (data.result.isSuccess) {
        setOrder(data.data);
        setServices(responseServices.data.data);
        setCounts(new Array(responseServices.data.data.length).fill(0));
        var sequence = 0;
        if (data.data.subscriptionId == null) {
          data.data.qrTagsById.map(function (tagRecord, i) {
            if (tagRecord.flow === 0) {
              qrScans.push({
                seq: sequence,
                img: tagRecord.serviceByServiceId.bagImageUrl,
                name: tagRecord.serviceByServiceId.nameEn,
                tag: tagRecord.tag,
                serviceId: tagRecord.serviceByServiceId.id,
                isScanned: false,
                isPerItem:
                  tagRecord.serviceByServiceId.id ==
                  localStorage.getItem("perItemServiceId"),
                items: {},
              });
              sequence = sequence + 1;
            }
          });
        }
      } else {
        showErrorNotification(data.result.description);
        if (data.result.code == -2) {
          redirectToLogout();
        }
      }
    } catch (ex) {
      showErrorNotification("Failed to fetch order details " + ex);
    }
    setIsLoading(false);
  };

  const isShowSaveButton = () => {
    return isAllScanged() && isImageUploaded() && isAllPerItemSet();
  };

  const isAllScanged = () => {
    for (var j = 0; j < qrScans.length; j++) {
      if (qrScans[j].isScanned === false) {
        return false;
      }
    }
    return true;
  };

  const isImageUploaded = () => {
    if (order != null && order.isShoeOrder == 1 && uploadFiles == null) {
      return false;
    }
    return true;
  };

  const isAllPerItemSet = () => {
    for (var j = 0; j < qrScans.length; j++) {
      if (qrScans[j].isPerItem) {
        if (!isPerItemSet(qrScans[j].items)) {
          return false;
        }
      }
    }
    return true;
  };

  const isPerItemSet = (items) => {
    if (Object.keys(items).length === 0) {
      return false;
    }
    for (const key in items) {
      if (items.hasOwnProperty(key) && items[key] !== 0) {
        return true;
      }
    }
    return true;
  };

  const getServiceTableRow = (sequence, img, name, qrScan, isPerItem) => {
    return (
      <TableRow key={sequence}>
        <TableCell>
          <img src={img} width="40px" />
        </TableCell>
        <TableCell style={{ fontSize: "24px", fontWeight: "bold" }}>
          {name}
        </TableCell>
        <TableCell style={{ fontSize: "24px", fontWeight: "bold" }}>
          {qrScan}
          {qrScan === "Scanned" && (
            <Box
              width="2rem!important"
              height="2rem!important"
              component={Check}
              color="green"
            />
          )}
        </TableCell>
        <TableCell>
          {order != null && order.isShoeOrder == 1 ? (
            <FormControl variant="outlined">
              <div className="fileinput">
                <div className={"thumbnail"}>
                  <img src={imageUrl} width="100px" />
                </div>
                <input
                  type="file"
                  id="imageFile"
                  onChange={(e) => handleImageChange(e, sequence)}
                  ref={fileInput}
                />
              </div>
            </FormControl>
          ) : (
            <TableCell></TableCell>
          )}
        </TableCell>
        <TableCell style={{ fontSize: "24px", fontWeight: "bold" }}>
          {isPerItem &&
          qrScans[sequence] != null && qrScans[sequence].items != null &&
          isPerItemSet(qrScans[sequence].items) ? (
            <>
              {"Items Set"}
              <Box
                width="2rem!important"
                height="2rem!important"
                component={Check}
                color="green"
              />
            </>
          ) : (
            ""
          )}

          {isPerItem ? (
            <Tooltip title="Set Items">
              <Button
                size="small"
                classes={{
                  root: classes.buttonContainedSuccess,
                }}
                variant="contained"
                style={{ marginLeft: "5px" }}
                onClick={() => {
                  setCounts([]);
                  setSelectedBagId(sequence);
                  setItemsModal(true);
                }}
              >
                Set Items
              </Button>
            </Tooltip>
          ) : (
            ""
          )}
        </TableCell>
      </TableRow>
    );
  };

  useAsyncEffect(async () => {
    // if(countChanges){
    //   setCountChanges(false);
    //   return;
    // }
    if (order == null) {
      fetchOrderDetails();
    }
  }, [order]);

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>
              <CardHeader
                subheader={
                  <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Tooltip title="Back">
                        <Button
                          size="small"
                          classes={{
                            root: classes.buttonContainedPrimary,
                          }}
                          variant="contained"
                          style={{ marginRight: "20px" }}
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          <Box component={ArrowBack} />
                        </Button>
                      </Tooltip>
                      <Box component="span">
                        Scan QR Codes for Order #
                        {order != null ? order.publicId : ""} and Mark as
                        Washing
                      </Box>
                    </Box>
                  </>
                }
                classes={{ root: classes.cardHeaderRoot }}
              ></CardHeader>
              {isLoading ? (
                <Box
                  component={Grid}
                  container
                  justifyContent="center"
                  className="justify-content-center"
                >
                  <div className="text-center" style={{ width: "20%" }}>
                    <LoadingAnimation />{" "}
                  </div>
                </Box>
              ) : (
                <Grid container>
                  <Grid item xs={12}>
                    <Grid container justify="space-between">
                      <Grid item xs={12} sm={12} md={12}>
                        <Card>
                          <CardHeader
                            subheader={
                              <>
                                <Box component="span">Scan Bags</Box>
                              </>
                            }
                            classes={{ root: classes.cardHeaderRoot }}
                          ></CardHeader>
                          <TableContainer
                            style={{
                              paddingLeft: "26px",
                              paddingRight: "26px",
                            }}
                          >
                            <Box
                              component={Table}
                              alignItems="center"
                              marginBottom="0!important"
                            >
                              <TableHead>
                                <TableRow>
                                  <TableCell
                                    classes={tableCellHeadTableHeadClassesObj}
                                  >
                                    Bag
                                  </TableCell>
                                  <TableCell
                                    classes={tableCellHeadTableHeadClassesObj}
                                  >
                                    Service
                                  </TableCell>

                                  <TableCell
                                    classes={tableCellHeadTableHeadClassesObj}
                                  >
                                    QR Scan
                                  </TableCell>
                                  <TableCell
                                    classes={tableCellHeadTableHeadClassesObj}
                                  >
                                    {order != null && order.isShoeOrder == 1
                                      ? "Upload Item Photo*"
                                      : ""}
                                  </TableCell>
                                  <TableCell
                                    classes={tableCellHeadTableHeadClassesObj}
                                  >
                                    Items
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {qrScans != null && qrScans.length > 0
                                  ? qrScans.map(function (service, i) {
                                      return getServiceTableRow(
                                        service.seq,
                                        service.img,
                                        service.name,
                                        service.isScanned
                                          ? "Scanned"
                                          : "Not Scanned",
                                        service.isPerItem
                                      );
                                    })
                                  : ""}
                              </TableBody>
                              {/* <br/><br/>
                              {order != null && order.isShoeOrder == 1 ? (<FormGroup>
                  <FormLabel>Upload Item Photo *</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                      <div className="fileinput">
                      <div className={"thumbnail"}>
                          <img src={imageUrl} width="100px" />
                        </div>
                        <input
                          type="file"
                          id="imageFile"
                          onChange={handleImageChange}
                          ref={fileInput}
                        />
                      </div>
                  </FormControl>
                </FormGroup>) : '' } */}
                            </Box>
                          </TableContainer>

                          <Grid container justify="space-between">
                            {!isShowSaveButton() ? (
                              <Grid item xs={12} sm={12} md={12}>
                                <Tooltip
                                  title="Add Bag"
                                  style={{ marginTop: "50px", width: "100%" }}
                                >
                                  <Button
                                    variant="contained"
                                    size="large"
                                    classes={{
                                      root: classes.buttonContainedWarning,
                                    }}
                                    onClick={() => {
                                      setScanQrModal(true);
                                    }}
                                  >
                                    <span>Scan QR</span>
                                  </Button>
                                </Tooltip>
                              </Grid>
                            ) : (
                              ""
                            )}
                            {isShowSaveButton() ? (
                              <Grid item xs={12} sm={12} md={12}>
                                <Tooltip
                                  title="Save"
                                  style={{ marginTop: "50px", width: "100%" }}
                                >
                                  <Button
                                    variant="contained"
                                    size="large"
                                    classes={{
                                      root: isAllScanged()
                                        ? classes.buttonContainedSuccess
                                        : classes.buttonContainedDisabled,
                                    }}
                                    onClick={() => {
                                      if (!isAllScanged()) {
                                        showErrorNotification(
                                          "Please scan all bags and set all items to proceed"
                                        );
                                      } else {
                                        updateStatusAction(4);
                                      }
                                    }}
                                  >
                                    <span>Save</span>
                                  </Button>
                                </Tooltip>
                              </Grid>
                            ) : (
                              ""
                            )}
                          </Grid>
                        </Card>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Card>
          </Grid>
        </Grid>

        <Dialog
          classes={{
            root: classes.center + " " + classes.modalRoot,
            paper: classes.modal + " " + classes.modalSmall,
          }}
          open={scanQrModal && !isLoading}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setScanQrModal(false)}
        >
          <DialogTitle disableTypography className={classes.modalHeader}>
            <h4 className={classes.modalTitle}>Scan QR</h4>
          </DialogTitle>
          <DialogContent
            className={classes.modalBody + " " + classes.modalSmallBody}
          >
            <Box
              component={Grid}
              container
              justifyContent="center"
              className="justify-content-center"
            >
              <QrReader
                delay={300}
                onError={handleQrError}
                onScan={handleQrScan}
                style={{ width: "50%" }}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setScanQrModal()}
              classes={{
                root: classes.buttonContainedPurple100,
              }}
              variant="contained"
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          classes={{
            root: classes.center + " " + classes.modalRoot,
            paper: classes.modal + " " + classes.modalSmall,
          }}
          open={itemsModal && !isLoading}
          TransitionComponent={Transition}
          fullScreen
          keepMounted
          onClose={() => setItemsModal(false)}
        >
          {/* <DialogTitle disableTypography className={classes.modalHeader}>
            
          </DialogTitle> */}
          {/* <DialogContent
            className={classes.modalBody + " " + classes.modalSmallBody}
          > */}
          <div className="item-dialog-main">
            <h4 className={classes.modalTitle}>Set Bag Items</h4>
            <br />
            {services.map(function (service, i) {
              if (service.isPerItem) {
                return (
                  <div className="per-item-dialog-container">
                    <div className="services-container">
                      <div className="main-service">
                        <img
                          src={service.bagImageUrl}
                          height="20px"
                          alt={service.nameEn}
                        />
                        <b>{service.nameEn}</b>
                      </div>
                      {service.servicesById.map(function (subService, j) {
                        if (counts[subService.id] == null) {
                          if (
                            selectedBagId != null && qrScans[selectedBagId] != null &&
                            qrScans[selectedBagId].items != null &&
                            qrScans[selectedBagId].items[subService.id] != null
                          ) {
                            counts[subService.id] =
                              qrScans[selectedBagId].items[subService.id];
                          } else {
                            counts[subService.id] = 0;
                          }
                        }
                        return (
                          <>
                            {j > 0 && <hr className="separator-line" />}
                            <div key={j} className="sub-service">
                              <span className="bullet">•</span>
                              <span className="sub-service-name">
                                {subService.nameEn}
                              </span>

                              <div className="count-container">
                                <img
                                  src={minusIcon}
                                  alt="Minus"
                                  className="count-button"
                                  onClick={() => decrementCount(subService.id)}
                                />
                                <span className="count-text">
                                  {counts[subService.id]}
                                </span>

                                <img
                                  src={plusIcon}
                                  alt="Plus"
                                  className="count-button"
                                  onClick={() => incrementCount(subService.id)}
                                />
                              </div>
                            </div>
                          </>
                        );
                      })}
                    </div>
                  </div>
                );
              }
            })}
          </div>
          {/* </DialogContent> */}
          <DialogActions>
            <Button onClick={() => setItemsModal(false)}>Cancel</Button>
            <Button
              onClick={() => {
                // var items = {};

                // counts.forEach(item => {
                //   items[item.id] = item.name;
                // });
                qrScans[selectedBagId].items = counts;
                setItemsModal(false);
              }}
              classes={{
                root: classes.buttonContainedPurple100,
              }}
              variant="contained"
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default ScanQrCodesPage;
